<mbs-modal [title]="'shared:captions.info' | i18next">
  <ng-container modal-body>
    <mbs-alert
      *ngIf="agent === agentType.RA"
      [type]="mbsPopupType.warning"
      [icon]="true"
      class="mb-4">
      {{ 'shared:computers.modals.reAuthComputerForConnectCentrilizedConfiguration' | i18next }}
      <a
        target="_blank"
        [helpLink]="'https://kb.msp360.com/kb10140'"
        [kbMode]="true">
        {{ 'shared:buttons.learnMore' | i18next }}
      </a>
    </mbs-alert>
    {{ confirmationQuestion }}
  </ng-container>
  <ng-container modalFooter>
    <mbs-button
      type="primary"
      (click)="baseModal.save()"
      >{{ 'shared:buttons.install' | i18next }}</mbs-button
    >
    <mbs-button (click)="baseModal.close()">{{ 'shared:buttons.close' | i18next }}</mbs-button>
  </ng-container>
</mbs-modal>
